<template>
  <soha-page-loading v-if="loading" />
  <div
    class="card card-custom gutter-b example example-compact p-8"
    v-else-if="!access"
  >
    <soha-no-access :message="$t(`${I18nPrefix}ACCESS_MESSAGE`)" />
  </div>
  <div v-else class="card card-custom gutter-b example example-compact p-8">
    <div class="row mx-0 mb-4">
      <div
        class="col-12 d-sm-flex d-block justify-content-between align-items-center text-center text-sm-left"
      >
        <span class="soha-page-title w-100 w-sm-50">
          {{ $t(`${I18nPrefix}PAGE_TITLE`) }}
        </span>
        <soha-button
          class="w-100 w-sm-180px mt-2 mt-sm-0"
          v-if="canDo.includes('createLinkId')"
          name="createLinkId"
          icon="plus"
          :text="$t(`${I18nPrefix}CREATE_LINK`)"
          @click="$bvModal.show('createLinkedId')"
        />
      </div>
      <div class="col-12">
        <p class="soha-page-description">
          {{ $t(`${I18nPrefix}PAGE_DESCRIPTION`) }}
        </p>
      </div>
    </div>

    <div>
      <soha-no-data
        v-if="linkedIds.length === 0"
        :message="$t(`${I18nPrefix}NO_DATA`)"
        class="m-auto"
      />
      <div v-else class="row">
        <div
          class="col-12 my-4"
          v-for="(item, index) in linkedIds"
          :key="index"
        >
          <div class="soha-linked-id-card">
            <div class="soha-linked-id-card-header">
              <span class="font-size-sm col-sm-1 col-2 p-0">
                {{ $t(`${I18nPrefix}ID`) }}
              </span>
              <span class="soha-linked-id-name col-sm-9 col-8 p-0">
                {{ item.text }}
              </span>
              <soha-menu
                class="col-2 p-0 d-flex justify-content-start"
                :closeByClickItem="false"
                v-if="
                  canDo.includes('updateMessagePattern') ||
                  canDo.includes('deleteMessagePattern')
                "
              >
                <template v-slot:activator>
                  <span name="messageCardMenu" class="cursor-pointer">
                    <inline-svg src="/media/svg/soha/btn-icons/menu.svg" />
                  </span>
                </template>
                <soha-list>
                  <soha-list-item
                    v-if="canDo.includes('deleteLinkId')"
                    class="primary-color"
                    :text="$t(`${I18nPrefix}DELETE`)"
                    icon="delete"
                    name="deleteLink"
                    @click="openDeleteModal(item)"
                  />
                  <label
                    class="direction-rtl mt-2 mb-0"
                    style="border-bottom: none !important"
                  >
                    {{ $t(`${I18nPrefix}SELECT_JOB`) }}
                  </label>
                  <soha-select
                    class="w-100 direction-rtl min-w-300px"
                    @onChange="createLink(item.id)"
                    v-model="selectedJobId"
                    :placeholder="$t(`${I18nPrefix}JOBS`)"
                    name="jobs"
                    :options="accessibleJobs"
                  />
                </soha-list>
              </soha-menu>
            </div>
            <div class="row m-0">
              <span class="font-size-sm col-12 px-0 mb-2">
                {{ $t(`${I18nPrefix}DESCRIPTION`) }}
              </span>
              <div class="soha-message-primary-text col-12 p-0 text-justify">
                {{ item.desc }}
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center w-100">
          <b-pagination
            class="mt-10"
            v-if="totalPages > perPage"
            pills
            @input="onPageChange"
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalPages"
          />
        </div>
        <input
          class="form-control"
          disabled
          type="text"
          style="display: block; opacity: 0; height: 0; width: 2.308rem"
          id="linkIdUrl"
        />
      </div>
    </div>
    <soha-modal
      id="createLinkedId"
      :title="$t(`${I18nPrefix}MODAL_TITLE`)"
      @hide="clearCreateModalData"
    >
      <template v-slot:body>
        <soha-text-field
          class="w-100"
          v-model.trim="linkedId.value"
          :error="linkedId.error"
          :placeholder="$t(`${I18nPrefix}ID_NAME`)"
          @onEnterPressed="createLinkedId"
        />
        <soha-text-area
          class="w-100"
          v-model.trim="description"
          :placeholder="$t(`${I18nPrefix}DESCRIPTION`)"
        />
      </template>
      <template v-slot:footer>
        <soha-button
          class="w-100"
          @click="createLinkedId"
          text="ایجاد"
          :loading="createLoading"
        />
      </template>
    </soha-modal>

    <soha-delete-modal
      @onDelete="deleteLinkedId(selectedLink)"
      :loading="deleteLoading"
      modal-id="deleteLink"
      :text="$t(`${I18nPrefix}DELETE_MESSAGE`)"
    />
  </div>
</template>

<script>
import UIMixin from "@/mixins/UIMixin";
import ApiService from "@/core/services/api.service";
import { mapGetters } from "vuex";
import ValidationMixin from "@/mixins/ValidationMixin";
export default {
  name: "LinkedId",
  mixins: [UIMixin, ValidationMixin],
  data() {
    return {
      I18nPrefix: "PAGES.SETTING.LINKED_ID.",
      access: true,
      loading: false,
      deleteLoading: false,
      createLoading: false,
      selectedLink: null,
      linkedId: {
        value: null,
        error: null,
      },
      description: null,
      accessibleJobs: [],
      linkedIds: [],
      selectedJobId: null,
      currentPage: this.$route.query.page ? this.$route.query.page : "1",
      totalPages: null,
      perPage: null,
    };
  },
  mounted() {
    this.getLinkedIds(true);
    this.getAccessibleJobs();
  },
  methods: {
    createLink(linkId) {
      let link;
      if (this.selectedJobId == "companyId=" + this.companyId) {
        link =
          this.$frontUrl +
          "jobOpportunity/?" +
          this.selectedJobId +
          "&linkId=" +
          linkId;
      } else {
        link =
          this.$frontUrl +
          "jobOpportunity/?companyId=" +
          this.companyId +
          "&job=" +
          this.selectedJobId +
          "&linkId=" +
          linkId;
      }
      this.copyLink(link);
    },

    copyLink(link) {
      let element = document.getElementById("linkIdUrl");
      element.disabled = false;
      element.value = link;
      element.select();
      document.execCommand("copy");
      element.disabled = true;
      this.successToast(this.$t(`${this.I18nPrefix}COPY_LINK_SUCCESS`));
      this.selectedJobId = null;
    },

    createLinkedId() {
      this.linkedId.error = this.validateField(
        this.linkedId.value,
        this.$t(`${this.I18nPrefix}ID_NAME`)
      );
      if (this.linkedId.error) return;
      this.createLoading = true;
      ApiService.post("api/employer/identifiableLink", {
        companyId: this.companyId,
        employerId: this.userId,
        text: this.linkedId.value,
        desc: this.description,
      }).then((res) => {
        if (res.data.status === "ok") {
          this.linkedIds.unshift({
            id: res.data.linkId,
            text: this.linkedId.value,
            desc: this.description,
          });
          this.createLoading = false;
          this.$bvModal.hide("createLinkedId");
          this.successToast(res.data.message);
        } else if (res.data.status === "error") {
          this.errorToast(res.data.message);
        }
      });
    },

    deleteLinkedId(item) {
      this.deleteLoading = true;
      ApiService.post("api/employer/deleteIdentifiableLink", {
        id: item.id,
      }).then((res) => {
        if (res.data.status === "ok") {
          this.linkedIds.splice(this.linkedIds.indexOf(item), 1);
          this.totalPages--;
          if (this.linkedIds.length === 0 && this.totalPages >= this.perPage) {
            this.currentPage =
              this.currentPage > 1 ? (this.currentPage - 1).toString() : "1";
            this.$router.push({ query: { page: this.currentPage } });
            this.getLinkedIds();
          }
          this.successToast(res.data.message);
          this.$bvModal.hide("deleteLink");
        } else if (res.data.status === "error") {
          this.errorToast(res.data.message);
        }
        this.deleteLoading = false;
      });
    },

    getAccessibleJobs() {
      ApiService.get(`api/v2/companies/${this.companyId}/jobs`).then((res) => {
        this.accessibleJobs = res.data.map((job) => {
          return {
            id: job.id,
            text: job.title,
          };
        });
        this.accessibleJobs.push({
          id: "companyId=" + this.companyId,
          text: "صفحه فرصت‌های شغلی",
        });
      });
    },

    getLinkedIds(loading) {
      this.loading = loading;
      ApiService.post(
        `api/employer/getAllIdentifiableLink?page=${this.currentPage}`,
        {
          companyId: this.companyId,
          employerId: this.userId,
        }
      ).then((res) => {
        if (res.data.status === "noAccess") {
          this.access = false;
        } else if (res.data.status === "error") {
          this.errorToast(res.data.message);
        } else {
          this.totalPages = res.data.total;
          this.perPage = res.data.per_page;
          this.linkedIds = res.data.data;
        }
        this.loading = false;
      });
    },

    onPageChange() {
      this.$router.push({ query: { page: this.currentPage } });
      this.getLinkedIds();
    },

    openDeleteModal(link) {
      this.selectedLink = link;
      this.$bvModal.show("deleteLink");
    },

    clearCreateModalData() {
      this.linkedId.error = this.linkedId.value = this.description = null;
    },
  },

  computed: {
    ...mapGetters(["companyId", "canDo", "userId"]),
  },
};
</script>

<style scoped>
.soha-page-description {
  color: var(--primary-color);
  margin-top: 1.538rem;
  font-weight: 600;
  text-align: justify;
}

.soha-linked-id-card {
  border: 0.077rem solid var(--box-border-color);
  border-radius: 0.462rem;
  padding: 0.769rem 1.154rem;
  height: 100%;
}
.soha-linked-id-card-header {
  display: flex;
  align-items: center;
  border-bottom: 0.077rem solid var(--box-border-color);
  padding-bottom: 0.769rem;
  margin-bottom: 0.769rem;
  color: var(--primary-color);
}
.soha-linked-id-name {
  color: var(--primary-color);
  font-weight: bold;
  text-align: right;
}
</style>
